import { API_URL } from './Constants';
import ApiService from './ApiService';
import { EditorState } from 'draft-js';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

class GuongSangTuHanhPageApi {

    // --------------- ADMIN -----------------
    static submitPost = async (formData) => {
        console.log("Data: ", formData)

        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);

        if(formData.content) {
            const rawContent = convertToRaw(formData.content.getCurrentContent());  // Get raw content
            const htmlContent = draftToHtml(rawContent);  // Convert to HTML
            data.append("content", htmlContent); // Assuming it's a string
        }

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/guong-sang-tu-hanh/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        console.log("Data: ", formData)

        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("isDeleteFile", formData.isDeleteFile);

        if(formData.content) {
            const rawContent = convertToRaw(formData.content.getCurrentContent());  // Get raw content
            const htmlContent = draftToHtml(rawContent);  // Convert to HTML
            data.append("content", htmlContent); // Assuming it's a string
        }

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/guong-sang-tu-hanh/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietGuongSangTuHanhAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };
            return await ApiService.getDataWithParams(API_URL + "/guong-sang-tu-hanh/detail", params);
        } catch (error) {
        }
    }
}

export default GuongSangTuHanhPageApi;